import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const timer = setTimeout(() => {
      // 1. Si ya existe, no reinicializar
      if (window.fbq) return;
      // 2. Definir fbq y _fbq correctamente
      const fbq = function (...args: any[]) {
        fbq.callMethod ? fbq.callMethod.apply(fbq, args) : fbq.queue.push(args);
      } as any;
      if (!window._fbq) window._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      window.fbq = fbq;
      // 3. Cargar el script de forma segura usando document.createElement
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      // 4. Añadir al head sin usar parentNode
      document.head.appendChild(script);
      // 5. Inicializar y trackear PageView
      window.fbq('init', '1313291250496067');
      window.fbq('track', 'PageView');
    }, 2000); // Retrasar 2 segundos para prioridad de renderizado
    return () => clearTimeout(timer);
  }, []);
  return null; // No renderizamos nada en el DOM para evitar conflictos
}